import { render, staticRenderFns } from "./MdmModal.vue?vue&type=template&id=7a4797c8&name=mdm-modal&"
import script from "./MdmModal.vue?vue&type=script&lang=js&"
export * from "./MdmModal.vue?vue&type=script&lang=js&"
import style0 from "./MdmModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./MdmModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports